import { CreateSoil, SearchSoil, UpdateSoil } from '@/types/soil'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const soilDataConfigApi = {
  getAll(searchParams: SearchSoil) {
    const url = 'api/soil'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/soil/getbyid?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateSoil) {
    const url = '/api/soil'
    return axiosClient.post(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/soil/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },

  update(payload: UpdateSoil) {
    const url = '/api/soil'
    return axiosClient.put(url, payload)
  },
}

export default soilDataConfigApi
